import { CreateReportRequest } from '@api';
import { ExternalCompoundFilterState } from '@trukt/ui/CompoundFilter';
import { getReportColumnsFromTableColumns } from '../../OrderListView.helpers';
import { OrderTableColumnLiterals } from '../../OrderListView.types';
import { MapBaseReportBodyProps } from './mapBaseReportBody.types';
import { OrderListCompoundFilterState } from '../../hooks/use-order-list-compound-filter';
import { extractLocationRadiusData } from '../../components/sub-topic-options/components/location-filter';

export const mapBaseReportBody = ({
  visibleColumns,
  compoundFilterState,
  filters,
  name,
}: MapBaseReportBodyProps) => {
  const body: CreateReportRequest['body'] = {
    columns: getReportColumnsFromTableColumns(visibleColumns as OrderTableColumnLiterals[]),
    compoundFilterState: fromOrderCompoundFiltersStateToExternalState(compoundFilterState),
    filter: filters,
    name: name.trim(),
    category: 'order',
    acl: 'owner',
  };

  return body;
};

function fromOrderCompoundFiltersStateToExternalState(
  filters: OrderListCompoundFilterState,
): ExternalCompoundFilterState {
  return filters.reduce<ExternalCompoundFilterState>(
    (acc, filter) => {
      if (!acc.itemIds.includes(filter.id)) acc.itemIds.push(filter.id);

      const index = acc.itemIds.indexOf(filter.id);

      if (!acc.selectedOptionIndexs[index]) acc.selectedOptionIndexs[index] = [];

      filter.options.forEach((option, optionIndex) => {
        if (!option.stateModifiers?.isActive) return;

        acc.selectedOptionIndexs[index].push(optionIndex);
      });

      acc.selectedItemIndex = filters.findIndex((filter) => filter.stateModifiers?.isActive);

      switch (filter.id) {
        case 'status':
          acc.options[index] = filter.options.map((option) => ({
            label: option.label,
            value: option.id,
            isClearable: true,
          }));
          break;

        case 'contacts':
          acc.options[index] = filter.options.map((option) => ({
            label: option.label,
            value: option.id,
            isClearable: true,
          }));
          break;

        case 'dates':
          acc.options[index] = filter.options.map((option) => ({
            label: option.label,
            value: {
              // @ts-expect-error - these properties are ok
              status: option.data?.dateTypeValue ?? '',
              // @ts-expect-error - these properties are ok
              startDate: option.data?.dateStart ?? null,
              // @ts-expect-error - these properties are ok
              endDate: option.data?.dateEnd ?? null,
            },
            isClearable: true,
            isRemovedOnClear: true,
          }));
          break;

        case 'pickup':
        case 'delivery':
          acc.options[index] = filter.options.map((option) => ({
            label: option.label,
            // @ts-expect-error - the type of data is the expected one.
            value: extractLocationRadiusData(option),
            isClearable: true,
            isRemovedOnClear: true,
          }));
          break;

        case 'branches':
          acc.options[index] = filter.options.map((option) => ({
            label: option.label,
            value: option.id,
            isClearable: true,
            isRemovedOnClear: true,
          }));
          break;

        default:
          break;
      }

      return acc;
    },
    { itemIds: [], selectedItemIndex: 0, selectedOptionIndexs: [], options: [] },
  );
}
